import httpClient, { IRequest, IResponse, TRequestHeaders } from '../../../../apiService/httpClient';
import { getLanguage } from '../../../localization';
import { ISlopedGabionParamsRequest, ISteppedGabionParamsRequest, IVerticalDropsParamsRequest } from '../IApiRequest';
import { ISlopedGabionResults, ISteppedGabionResults, IVerticalDropsResults } from '../IApiResponse';

const BeMaccaferriCalculationProvider = () => {
    let _baseURL = (process.env.ENVIRONMENT as string) === 'local' ? process.env.CALCULATION_BASE_URL as string : '/';

    const _createRequest = <D>(_pathname: string, _queryString?: string, _data?: D): IRequest => {
        return {
            url: _queryString ? _pathname + '?' + _queryString : _pathname,
            baseURL: _baseURL,
            data: _data,
        };
    };

    const _createHeaders = (): TRequestHeaders => {
        return {
            'Accept-Language': getLanguage(),
        };
    };

    //calculation
    const getSlopedResultsAsync = async (data: ISlopedGabionParamsRequest): Promise<IResponse<ISlopedGabionResults>> =>
        httpClient.postAsync(_createRequest(`api/CalculationSloped/GetResultsMacra2Sloped`, '', data), _createHeaders());
    const getSteppedResultsAsync = async (data: ISteppedGabionParamsRequest): Promise<IResponse<ISteppedGabionResults>> =>
        httpClient.postAsync(_createRequest(`api/CalculationStepped/GetResultsMacra2Stepped`, '', data), _createHeaders());
    const getVerticalResultsAsync = async (data: IVerticalDropsParamsRequest): Promise<IResponse<IVerticalDropsResults>> =>
        httpClient.postAsync(_createRequest(`api/CalculationVerticalDrops/GetResultsMacra2Vertical`, '', data), _createHeaders());

    return {
        getSlopedResultsAsync,
        getSteppedResultsAsync,
        getVerticalResultsAsync,
    };
};
export default BeMaccaferriCalculationProvider();
